import { NoEditorSDKProvidedForEditorSDKMode } from '../../contexts/SettingsContext/NoEditorSDKProvidedForEditorSDKMode';
import { createEditorSDKAdapter } from './editorSDKAdapter';
import { createWixSDKAdapter } from './wixSDKAdapter';
export function createSDKAdapter(_a) {
    var componentRef = _a.componentRef, WixSDK = _a.WixSDK, editorSDK = _a.editorSDK;
    if (componentRef) {
        if (!editorSDK) {
            throw new NoEditorSDKProvidedForEditorSDKMode();
        }
        return createEditorSDKAdapter(editorSDK, componentRef);
    }
    return createWixSDKAdapter(WixSDK);
}
//# sourceMappingURL=sdk.js.map